import { ModalV4 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';

import InformationModalContent from './InformationModalContent';
import { data } from './InformationModalContent/data';
import OutOfStockModalContent from './OutOfStockModalContent';
import SizingModalContent from './SizingModalContent';
import type { ModalType } from './useModalState';

export interface HardwarePDPModalsProps {
  readonly activeModal: ModalType;
  readonly closeModal: () => void;
}

export default function HardwarePDPModals({
  activeModal,
  closeModal,
}: HardwarePDPModalsProps) {
  const handleOnOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      closeModal();
    }
  };

  return (
    <ModalV4
      dialogClassName="p-0"
      isOpen={activeModal !== null}
      onOpenChange={handleOnOpenChange}
      variant={activeModal === 'outOfStock' ? 'small' : 'large'}
    >
      <div
        className={cx(
          'w-full overflow-hidden p-6 pt-0 pb-5 text-sandstone-500 md:p-8',
          {
            'lg:w-[min(75vw,837px)]': activeModal !== 'outOfStock',
          },
        )}
        data-cy="hardware-pdp-modal-content"
      >
        {activeModal === 'warranty' && (
          <InformationModalContent {...data.warranty} />
        )}
        {activeModal === 'membership' && (
          <InformationModalContent {...data.membership} />
        )}
        {activeModal === 'sizing' && <SizingModalContent />}
        {activeModal === 'outOfStock' && (
          <OutOfStockModalContent onSubmit={closeModal} oosRingSku="" />
        )}
      </div>
    </ModalV4>
  );
}
